
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class Avatar extends Vue {
  @Prop({ type: String, required: false, default: 'purple' }) public color: string;
  @Prop({ type: String, required: false, default: '400' }) public colorIntensity: string;
  @Prop({ type: String, required: false, default: null }) public img: string;
  @Prop({ type: String, required: false, default: null }) public firstName: string;
  @Prop({ type: String, required: false, default: null }) public lastName: string;

  public get URL(): string {
    const url = process.env.VUE_APP_API?.replace(/api/i, '');
    const fullUrl = url + this.img;
    return fullUrl;
  }
}
